import { render } from "./App.vue?vue&type=template&id=0f1c0a1b"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0f1c0a1b&lang=css"
script.render = render

export default script